<template>
  <div id="app">
    <div class="row">
      <div class="col-sm-12">
        <h3 style="text-align: center;">
          VISOR DE MAPA: EJECUCION DE ENCUESTAS
        </h3>
        <google-map
          :latitude="latitude"
          :longitude="longitude"
          :title="title"
        />
      </div>
    </div>

  </div>
</template>

<script>
import GoogleMap from './GoogleMap.vue'

export default {
  components: {
    GoogleMap,
  },
  data: () => ({
    latitude: -6.0220945,
    longitude: -76.9884157,
    title: 'Título de Marcador',
  }),
}
</script>
